import React from 'react';

const RedTrashIcon = () => {
    return (
       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H21" stroke="#A50D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            
            <path 
            d="M8 6V2H16V6" 
            stroke="#A50D0D" 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
        />
            
            <path 
                d="M19 10V22H5V10" 
                stroke="#A50D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" 
            />
            
            <path d="M10 17V10" stroke="#A50D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 17V10" stroke="#A50D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default RedTrashIcon;
